<template>
  <aside class="sidebar">
    <div class="sidebar__fixed">
      <!-- Conteúdo da barra lateral -->
      <slot name="sidebar-content" />
    </div>
  </aside>
</template>

<script>
/** Componente da barra lateral que compõe alguns layouts */
export default {
  name: 'Sidebar'
}
</script>

<style lang="scss" scoped>
.sidebar {
  position: relative;
  width: 250px;
  background-color: $white;

  &__fixed {
    position: sticky;
    /** espaço do header */
    top: 50px;
  }
}
</style>
